export const transformBusinessForMap = (business) => {
    // Coordinates handling:
    // - business.latitude field should contain LATITUDE values (27-30 range)
    // - business.longitude field should contain LONGITUDE values (80-88 range)
    // - business.location.coordinates array should be [latitude, longitude]
    
    // Prefer coordinates array (correct format), fallback to separate fields
    let lat, lng;
    
    if (business.location?.coordinates && Array.isArray(business.location.coordinates) && business.location.coordinates.length >= 2) {
        // Use coordinates array directly (already in correct format)
        lat = business.location.coordinates[0]; // latitude
        lng = business.location.coordinates[1]; // longitude
    } else if (business.latitude !== undefined && business.longitude !== undefined) {
        // Use separate fields directly (assuming they are now correct)
        lat = business.latitude;
        lng = business.longitude;
        
        // Validate coordinate ranges and swap if needed
        // Nepal latitude range: ~26-30°N
        // Nepal longitude range: ~80-88°E
        if (lat > 30 || lat < 26) {
            // If lat is outside Nepal range, it might be longitude
            if (lng >= 26 && lng <= 30) {
                // Swap them - lat is actually longitude, lng is actually latitude
                console.log('Swapping coordinates for', business.name, '- lat:', lat, 'lng:', lng);
                [lat, lng] = [lng, lat];
            }
        }
    } else {
        // Fallback to Nepal center
        lat = 27.699585;
        lng = 85.328334;
    }
    
    return {
        id: business.id,
        name: business.name || 'Unknown',
        lat: lat,
        lng: lng,
        tag: business.tag || business.id,
        tags: business.tag ? [business.tag] : [],
        address: business.address || business.mapAddress?.generalAddress || 'No address',
        description: business.description || business.tagLine || '',
        rating: business.averageRating || 0,
        distance: business.distance || 0,
        contact: business.contact || '',
        website: business.website || '',
        avatar: business.avatar || '',
        category: business.category?.name || '',
        categoryIcon: business.category?.iconUrl || '',
    };
};
